<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span>Vị trí</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="searchAddressInput"
                :append-outer-icon="'mdi-magnify'"
                label="Nhập vào Địa chỉ"
                type="text"
                @click:append-outer="searchLocation"
                autofocus
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <GmapMap
                ref="gmap"
                :center="{lat:currentLocation.lat, lng:currentLocation.lng}"
                :zoom="8"
                :options="mapOptions"
                style="width: 100%; height: 400px"
                @click="mark"
              >
                <GmapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                />
              </GmapMap>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="get"
        >
          Lấy vị trí
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {}
    },
    data () {
      return {
        loading: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        mapOptions:{
          draggableCursor: 'default',
          draggingCursor: 'pointer',
          mapTypeControl: true,
          disableDefaultUI:true
        },
        markers: [ {
          position: {lat : 10.3887585, lng : 106.0303665}
        }],
        currentLocation : { lat : 10.3887585, lng : 106.0303665},
        searchAddressInput: null,
        dialog: false,
        submitted: false
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist = false;
        if (this.showDialog) {
          this.dialog = true;
          if(this.item.address){
            this.searchAddressInput=this.item.address;
            this.searchLocation();
          }
        }
      }
    },
    methods: {
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      mark(event) {
        this.currentLocation.lat = event.latLng.lat();
        this.currentLocation.lng = event.latLng.lng();
        this.markers = [{
          position: this.currentLocation
        }];
      },
      searchLocation() {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({'address': this.searchAddressInput}, (results, status) => {
          if (status === 'OK') {
            this.currentLocation.lat = results[0].geometry.location.lat();
            this.currentLocation.lng = results[0].geometry.location.lng();
            this.markers = [{
              position: this.currentLocation
            }];
          }
        });
      },
      // current position
      geolocation : function() {
        navigator.geolocation.getCurrentPosition((position) => {
          this.currentLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
        });
      },
      get() {
        this.dialog = false;
        this.$emit('confirmed', this.currentLocation);
      },
      save(item) {
        const app = this;
        let method = "post";
        let url = `api/v1/businesses`;
        let data = item;
        
        if (data.id) {
          method = "patch";
          url = `api/v1/businesses/${data.id}`;
        }

        app.loading=true;
        
        axios[method](url, data)
          .then((response) => {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            }
            app.loading=false;
          }).catch(function (error) {
            app.loading=false;
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      }
    }
  }
</script>